import { render, staticRenderFns } from "./chat-count.vue?vue&type=template&id=90420ff8"
import script from "./chat-count.vue?vue&type=script&lang=js"
export * from "./chat-count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports